<template>
  <!-- 找回密码 -->
  <div class="uni-login">
    <div class="login-content">
      <h1 style="text-align: center">找回密码</h1>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <div class="uni-input-group">
          <span
            class="uni-label"
            :class="{
              active: isLabelActive == 'password' || ruleForm.password != '',
            }"
            @click="inputGroupClick"
            >请输入电话号码</span
          >

          <el-form-item prop="mobile" class="uni-input">
            <el-input
              v-model.trim="ruleForm.mobile"
              @focus="changeLabelFocus"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 验证码 -->
        <div class="uni-input-group">
          <span
            class="uni-label"
            :class="{
              active:
                isLabelActive == 'rePassword' || ruleForm.rePassword != '',
            }"
            @click="inputGroupClick"
            >请输入验证码</span
          >

          <el-form-item prop="ver_code" class="uni-input">
            <el-input
              v-model.trim="ruleForm.ver_code"
              @focus="changeLabelFocus"
            >
              <el-button
                slot="suffix"
                type="primary"
                plain
                :disabled="!isShow"
                @click="getCode"
                ><span v-if="isShow">获取验证码</span
                ><span v-if="!isShow">{{ timerCount }}s</span></el-button
              >
            </el-input>
          </el-form-item>
        </div>

        <el-button type="primary" class="refer-btn" @click="refer('ruleForm')"
          >确定</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCode, verifyCode } from "@/api/login";
import { mobileReg } from "@/utils/regExp";

export default {
  name: "ChangePwd",
  components: {},
  data() {
    //  手机号正则
    const phoneReg = (rule, value, callback) => {
      let Reg = mobileReg;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!Reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    //  验证码
    const verifyCode = (rule, value, callback) => {
      let Reg = /^[0-9]{6}$/;
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!Reg.test(value)) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false, //test
      activeName: "first",
      isActive: false,
      isLabelActive: "",
      timerCount: 60,
      ruleForm: {
        mobile: "",
        ver_code: "",
      },
      rules: {
        mobile: [
          {
            validator: phoneReg,
            trigger: "blur",
          },
        ],
        ver_code: [
          {
            validator: verifyCode,
            trigger: "blur",
          },
        ],
      },
      //  发送验证按钮
      isShow: true,
      //  定时器
      timer: null,
    };
  },
  mounted() {},
  methods: {
    // label动画
    inputGroupClick(event) {
      const target = event.currentTarget;
      target.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.focus();
    },
    changeLabelFocus(event) {
      const { name } = event.currentTarget;
      this.isLabelActive = name;
    },
    // 提交
    refer(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          verifyCode(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$router.replace({
                path: "/forgetPwd",
                query: {
                  mobile: this.ruleForm.mobile,
                },
              });
            }
          });
        }
      });
    },
    //  获取验证码按钮
    getCode() {
      let Reg = mobileReg;
      if (Reg.test(this.ruleForm.mobile)) {
        this.isShow = false;
        //  发送手机验证码
        this.getVerificationCode();
        this.timer = setInterval(() => {
          this.timerCount--;
          if (this.timerCount === 0) {
            this.isShow = true;
            this.timerCount = 60;
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        this.$message.error("请输入正确的手机号");
      }
    },
    //验证码请求
    async getVerificationCode() {
      const params = {
        mobile: this.ruleForm.mobile,
      };
      getCode(params);
    },
  },
};
</script>

<style lang="scss">
// elementUi样式覆盖
.uni-login {
  .el-input__inner {
    border: none;
    border-bottom: 1px solid $gray;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.uni-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/login_bg.png") #eaeef7 center no-repeat;

  .login-content {
    width: 520px;
    background: $white;
    float: right;
    padding: 60px;
  }

  .refer-btn {
    width: 100%;
    height: 56px;
    border-radius: 28px;
    margin-top: 85px;
    font-size: 16px;
  }

  .uni-input-group {
    position: relative;
    margin-top: 40px;

    .uni-label {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #999;
      transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      font-size: 16px;
      transform-origin: left top;
      z-index: $zindexTooltip;

      &.active {
        transform: translateY(-120%) scale(0.8);
      }
    }

    .iconfont {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 22px;
    }

    .el-button {
      height: 30px;
      line-height: 0;
    }
  }
}
</style>
